module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/cooking/baking-glove-43fa7bb8b81a801005f219bf1e51baa8.svg";